import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { NavLinks } from "../../components/Navbar/NavLinks";
import { DeviceSize } from "../../utils/constants";
import { MobileNavLinks } from "../../components/Navbar/MobileNavLink";
import LogoutButton from "../../components/Navbar/LogoutButton";
import LanguageSelector from "../../components/LanguageSelector";

const Logo = require("../../assets/sCaptchaLogo.png");

export function Navbar() {
  const isMobile = useMediaQuery({ maxWidth: DeviceSize.mobile });

  return (
    <NavbarContainer>
      <Container>
        <LeftSection>
          <Link to="/account">
            <LogoImg src={Logo} alt="logo" />
          </Link>
        </LeftSection>
        <MiddleSection>{!isMobile && <NavLinks />}</MiddleSection>
        {isMobile && <LanguageSelector />}
        <RightSection>
          {!isMobile && (
            <RightSectionContainer>
              <LanguageSelector />
              <LogoutButton />
            </RightSectionContainer>
          )}
          {isMobile && <MobileNavLinks />}
        </RightSection>
      </Container>
    </NavbarContainer>
  );
}

const NavbarContainer = styled.div`
  width: 100%;
  box-shadow: 0 4px 6px rgb(22 22 26 / 18%);
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 1.5em;
`;

const Container = styled.div`
  margin: 0 auto;
  width: 1320px;
  height: 60px;
  display: flex;
  justify-content: space-between;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;

  a {
    display: flex;
  }
`;

const MiddleSection = styled.div`
  display: flex;
  flex: 2;
  height: 100%;
  justify-content: center;
`;

const RightSection = styled.div`
  display: flex;
`;

const LogoImg = styled.img`
  height: 30px;
`;
const RightSectionContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
